module.exports = __webpack_public_path__ + "static/media/otago_blur.acab10d5.png";